import * as Device from 'expo-device';

import {Alert, Platform, Text} from 'react-native';
import {dispatchAction, getReduxState} from './src/Utils/helpers';

import {LogBox} from 'react-native';

import {setAlertOpen} from './src/Redux/reducers/current_screen.reducer';

import {crashlytics} from './src/Utils/db';

Text.defaultProps = Text.defaultProps || {};
Text.defaultProps.allowFontScaling = false;

LogBox.ignoreLogs([
  "[react-native-gesture-handler] Seems like you're using an old API with gesture components, check out new Gestures system!",
]);

String.prototype.capitalizeWords = function () {
  let previousLetterSpace = true;
  return [].map
    .call(this, function (letter) {
      if (previousLetterSpace) {
        previousLetterSpace = false;
        return letter?.toUpperCase?.();
      } else {
        if (letter === ' ') {
          previousLetterSpace = true;
        }
        return letter?.toLowerCase?.();
      }
    })
    .join('');
};
var log;
if (!log) {
  if (__DEV__) {
    log = console.log;
  } else {
    log = console.log;
  }

  // only logging on dev
  console.log = function (a, b) {
    // setTimeout(() => {
    try {
      // getting first 200 characters of a string for crashlytics for speed
      const aString =
        typeof a == 'object' ? JSON.stringify(a)?.substring(0, 200) : a;

      // chrashytics recording
      // only logging a string for speed
      // limits that to 200 charact
      crashlytics?.().log?.(aString);

      // dev logging
      if (
        __DEV__ ||
        (Platform.OS == 'web' && window?.location?.href?.includes('show'))
      ) {
        b ? log?.(a, b) : log?.(a);
      }
    } catch (e) {
      log({a, b, e});
      // do nothing
    }
    // }, 0);
  };

  // log that also works on production
  // useful for expoupdatecontroller
  console.log_on_production = function (a, b) {
    try {
      const aString =
        typeof a == 'object' ? JSON.stringify(a)?.substring(0, 1000) : a;
      // only logging shorter start
      const bString =
        typeof b == 'object' ? JSON.stringify(b)?.substring(0, 1000) : b;
      crashlytics?.().log?.(aString + (bString || ''));

      b ? log?.(a, b) : log?.(a);
    } catch (e) {
      log({a, b});
      // do nothing
    }
  };
  if (!__DEV__) {
    console.warn('logs suppressed because production');
  }
}

global.appStarted == false;
global.color = {
  orange: 'rgba(232, 119, 34, 1)',
  teal: 'rgba(106, 174, 170, 1)',
  gray1: 'rgba(217, 217, 214, 1)',
  gray2: 'rgba(167, 168, 170, 1)',
  gray3: 'rgba(80, 87, 89, 1)',
  blue: 'rgba(83, 166, 196, 1)',
  blue_30: 'rgba(83, 166, 196, .3)',
  blue_50: 'rgba(83, 166, 196, .5)',
  blue_60: 'rgba(83, 166, 196, .6)',
  blue_80: 'rgba(83, 166, 196, .8)',
  yellow: 'rgba(255, 198, 0, 1)',
  white: 'rgba(255, 255, 255, 1)',
  white1: '#f2f2f2',
  orange_30: 'rgba(232, 119, 34, 0.3)',
  orange_50: 'rgba(232, 119, 34, 0.5)',
  teal_30: 'rgba(106, 174, 170, 0.3)',
  teal_50: 'rgba(106, 174, 170, 0.5)',
  teal_70: 'rgba(106, 174, 170, 0.7)',
  teal_80: 'rgba(106, 174, 170, 0.8)',
  gray1_30: 'rgba(217, 217, 214, 0.3)',
  gray1_50: 'rgba(217, 217, 214, 0.5)',
  gray1_80: 'rgba(217, 217, 214, 0.8)',
  gray2_50: 'rgba(167, 168, 170, 0.5)',
  gray3_30: 'rgba(80, 87, 89, 0.3)',
  gray3_50: 'rgba(80, 87, 89, 0.5)',
  gray3_60: 'rgba(80, 87, 89, 0.6)',
  gray3_80: 'rgba(80, 87, 89, 0.8)',
  yellow_50: 'rgba(255, 198, 0, 0.5)',
  white_30: 'rgba(255, 255, 255, 0.3)',
  white_50: 'rgba(255, 255, 255, 0.5)',
  white_70: 'rgba(255, 255, 255, 0.7)',
  white_80: 'rgba(255, 255, 255, 0.8)',
  white_90: 'rgba(255, 255, 255, 0.9)',
  black_10: 'rgba(0, 0, 0, 0.1)',
  black_20: 'rgba(0, 0, 0, 0.2)',
  black_30: 'rgba(0, 0, 0, 0.3)',
  black_50: 'rgba(0, 0, 0, 0.5)',
  black_60: 'rgba(0, 0, 0, 0.6)',
  black_70: 'rgba(0, 0, 0, 0.7)',
  black_80: 'rgba(0, 0, 0, 0.8)',
  gold: 'gold',
  silver: 'silver',
  bronze: '#d58c03',
  red: '#e22222',
  pink: '#E24260',
  magenta: '#de2795',
  purple: '#9166fb',
  lightblue: '#E5F2F6',
  darkblue: '#38556F',
  brightgreen: '#2AD55C',
};

global.localWeb = true && __DEV__ && !Device.isDevice;
global.currentScreen = '';

//code push development key
global.code_push_key =
  Platform.OS == 'android'
    ? 'ydPrbuQXZSnibeXqj7qvuhetP3vwS1rGETATE'
    : '_pZV53GGY-P0PxWn9y93XRAVNG4Tr1ofqtlTE';

global.font = {
  gothic: 'Alternate Gothic No3 D',
  gothic1: 'Alternate Gothic No1 D', // not in use
  circular: 'CircularStd-Book',
  circularBold: 'CircularStd-Bold',
};

global.style = {
  navigationHeader: {
    backgroundColor: global.color.white,
    borderBottomWidth: 0,
    elevation: 3,
    shadowColor: global.color.gray2,
    shadowRadius: 2,
    shadowOpacity: 0.3,
    shadowOffset: {
      height: 3,
    },
  },
  center: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    justifyContent: 'center',
  },
  noShadowNavigationHeader: {
    backgroundColor: global.color.white,
    borderBottomWidth: 0,
    elevation: 0,
    shadowColor: 'transparent',
    shadowRadius: 0,
    shadowOpacity: 0,
    shadowOffset: {
      height: 0,
    },
  },
  boxShadow: {
    backgroundColor: global.color.white,
    elevation: 3,
    shadowColor: global.color.gray3,
    shadowRadius: 4,
    shadowOpacity: 0.3,
    shadowOffset: {
      height: 2,
    },
  },
  fillAbsolute: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
};

global.customMapStyle = [
  {
    featureType: 'administrative',
    elementType: 'geometry',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'poi',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
];

const devAlert = (data, multiAlert = 0, allowNotOnDev = 0) => {
  console.log('devAlert fired');
  if (__DEV__ || allowNotOnDev) {
    const alertOpen = getReduxState(['current_screen', 'alertOpen']);
    // if (!alertOpen) {

    if (!alertOpen) {
      !multiAlert && dispatchAction(setAlertOpen(1));
      Alert.alert(
        '' + alertOpen,
        typeof data == 'object' ? JSON.stringify(data) : data + '',
        [
          {
            text: 'Close',
            onPress: () => !multiAlert && dispatchAction(setAlertOpen(0)),
          },
        ],
      );
    }

    //   dispatchAction(setAlertOpen(0));
    // }
  }
  // }
};

global.devAlert = devAlert;

global.checkoutTimeLimit = 10;

if (Platform.OS == 'web') {
  window.state = (path) => {
    return getReduxState(path);
  };
}
